const money = (v) =>
  Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });

function Card({ title, value, subtitle, icon, isPrimary = false }) {
  return (
    <article
      className={[
        'rounded-2xl border bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md',
        isPrimary ? 'border-red-200' : 'border-slate-200',
      ].join(' ')}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">{title}</p>
          <p className="mt-2 text-2xl font-bold text-slate-900">{value}</p>
          <p className="mt-1 text-xs text-slate-500">{subtitle || ' '}</p>
        </div>
        <div
          className={[
            'rounded-xl border p-2.5',
            isPrimary
              ? 'border-red-100 bg-red-50 text-red-600'
              : 'border-slate-200 bg-slate-100 text-slate-600',
          ].join(' ')}
        >
          {icon}
        </div>
      </div>
      <div className={['mt-4 h-1 w-12 rounded-full', isPrimary ? 'bg-red-500' : 'bg-slate-300'].join(' ')} />
    </article>
  );
}

export default function FinanzasKPICards({ resumen }) {
  const {
    total_monto_abonado = 0,
    total_pagos = 0,
    monto_caja_chica = 0,
    pagos_caja_chica = 0,
    monto_cuenta_corriente = 0,
    pagos_cuenta_corriente = 0
  } = resumen || {};

  return (
    <section className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <Card
        title="Total Abonado"
        value={money(total_monto_abonado)}
        subtitle={`${total_pagos} pagos en total`}
        isPrimary
        icon={
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      />

      <Card
        title="Total Pagos"
        value={total_pagos}
        subtitle="Movimientos aplicados"
        icon={
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />

      <Card
        title="Caja Chica"
        value={money(monto_caja_chica)}
        subtitle={`${pagos_caja_chica} pagos`}
        icon={
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        }
      />

      <Card
        title="Cuenta Corriente"
        value={money(monto_cuenta_corriente)}
        subtitle={`${pagos_cuenta_corriente} pagos`}
        icon={
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
          </svg>
        }
      />
    </section>
  );
}

